const langArr = {
  unit: { ua: 'Зміни душі', ru: 'Изменение души', en: 'Soul change' },
  about: { ua: 'Про мене', ru: 'Обо мне', en: 'About me' },
  about1: { ua: 'Про мене', ru: 'Обо мне', en: 'About me' },
  about2: { ua: 'Про мене', ru: 'Обо мне', en: 'About me' },
  what: { ua: 'Чим я допомогаю', ru: 'Чем я помогаю', en: 'How can I help' },
  what1: { ua: 'Чим я допомогаю', ru: 'Чем я помогаю', en: 'How can I help' },
  what2: { ua: 'Чим я допомогаю', ru: 'Чем я помогаю', en: 'How can I help' },
  price: { ua: 'Ціна', ru: 'Цена', en: 'Price', en: 'Price' },
  price1: { ua: 'Ціна', ru: 'Цена', en: 'Price', en: 'Price' },
  contact: { ua: 'Контакти', ru: 'Контакты', en: 'Contacts' },
  contact1: { ua: 'Контакти', ru: 'Контакты', en: 'Contacts' },

  heroCit: {
    ua: 'Зміни душі починаються звідси. Дозволь тобі допомогти!',
    ru: 'Изменение души начинается отсюда. Позволь тебе помочь!',
    en: 'Changes in the soul begin here. Let me help you!',
  },
  aboutMe: {
    ua: 'Мене звати Катерина Сербін і я слідую за своїм призначенням. Якщо ви натрапили на мене, чи на мою сторінку, це означає, що я можу вам допомогти. Я веду консультації Таро більше 10 років. Знаю. Вмію. Практикую. Але! Постійно перебуваю в потоці навчання. Тому що, це веде до розвитку і збільшення сили. Сила, що в мені - від роду. Так вийшло, що вона була перервана, а знання мені доводиться виборювати і знаходити кожен день самостійно. Кожна людина - мій вчитель. Кожна втрата чи проблема - мій урок. Світ змінюється, люди змінюються, тому кожен потребує підказок, які дає душа. Я - провідник цих підказок. Я можу вам допомогти.',
    ru: 'Меня зовут Екатерина Сербин и я следую за своим предназначением. Если вы наткнулись на меня или на мою страницу, это значит, что я могу вам помочь. Я веду консультации Таро больше 10 лет. Я знаю. Умею. Практикую. Но! Постоянно нахожусь в потоке обучения. Потому что это ведет к развитию и увеличению силы. Сила, что во мне – от роду. Так получилось, что она была прервана, а знания мне приходится бороться и находить каждый день самостоятельно. Каждый человек – мой учитель. Каждая потеря или проблема – мой урок. Мир меняется, люди меняются, поэтому каждый нуждается в подсказках, которые дает душа. Я – проводник этих подсказок. Я могу помочь вам.',
    en: 'My name is Kateryna Serbin and I follow my purpose. If you come across me or mine page, that means I can help you. I conduct tarot consultations more than 10 years. I know I can I practice. But! I am constantly in the flow teaching. Because it leads to the development and increase of strength. The power that to me - from my family. It so happened that it was interrupted, and the knowledge to me you have to choose and find each day independently. Every person - my teacher Every loss or problem is my lesson. The world is changing, people change, so everyone needs the hints that the soul gives. I am a conductor these tips. Can I help you.',
  },

  yoga: { ua: 'Йога', ru: 'Йога', en: 'Yoga' },
  yogaPr: {
    ua: 'Почніть свій шлях з гармонії. Відчуйте себе, свої бажання. Почуйте свою душу. Йога допоможе збалансувати ваше життя. Стреси, тягар, панічні атаки і багато іншого можна виправити. Все можна стабілізувати і відчути духовне зростання. Доступні заняття групові, індивідуальні та онлайн. Додаю медитації по запиту, який вас хвилює.',
    ru: 'Начните свой путь с гармонии. Почувствуйте себя, свои желания. Услышьте свою душу. Йога поможет сбалансировать вашу жизнь. Стрессы, бремя, панические атаки и многое другое можно исправить. Все можно стабилизировать и ощутить духовный рост. Доступные занятия групповые, индивидуальные и онлайн. Добавляю медитации по запросу, который вас волнует.',
    en: 'Start your journey with harmony. Feel yourself, your desires. Hear your soul. Yoga will help balance your life. Stress, burden, panic attacks and many other things can be corrected. Everything can be stabilized and spiritual growth can be felt. Group, individual and online classes are available. I am adding meditations on the request that worries you.',
  },
  taro: {
    ua: 'Таро консультації',
    ru: 'Таро консультации',
    en: 'Tarot consultation',
  },
  taroPr: {
    ua: 'Я провідник інформації. Карти - інструмент. Ви не можете розібратися в собі, в близькій людині чи своєму житті? Ви не розумієте, як і куди йти далі? Ви хочете знати варіанти свого майбутнього? Вам страшно, боляче, незрозуміло? Можемо провести як особисту зустріч так і онлайн сесію. Я на вас чекаю.',
    ru: 'Я проводник информации. Карты – инструмент. Вы не можете разобраться в себе, в близком человеке или своей жизни? Вы не понимаете, как и куда идти дальше? Вы хотите знать варианты своего будущего? Вам страшно, больно, непонятно? Можем провести как личную встречу и онлайн сессию. Я жду вас.',
    en: 'I am a conductor of information. Maps are a tool. You cant understand yourself, a loved one or your life? You do not understand how and where to go next? Do you want to know the options for your future? Are you afraid, hurt, unclear? We can hold both a personal meeting and an online session. I am waiting for you.',
  },
  lila: {
    ua: 'Трансформаційна гра "Ліла Чакра"',
    ru: 'Трансформационная игра "Лила Чакра"',
    en: 'Transformation game "Lila Chakra"',
  },
  lilaPr: {
    ua: 'Грати в цю гру - значить доторкнутися до божественної мудрості. В гру приходять із запитом. Запит повністю може пропрацюватися за сеанс, що може замінити роки відвідування психолога. Я проводжу вас до глибинної суті. Тривалість гри може бути багатогодинна, тому сплануємо день разом. В середньому, індивідуальна гра проходить близько 4 годин. Хто я? Чому я прийшов/прийшла саме в цей час? Яке моє призначення? А також багато інших запитів, що стосуються життя. Доступна в онлайн режимі. До зустрічі🙏',
    ru: 'Играть в эту игру – значит прикоснуться к божественной мудрости. В игры приходят с запросом. Запрос полностью может проработать по сеанс, который может заменить годы посещения психолога. Я провожу вас в глубинную сущность. Продолжительность игры может быть многочасовой, поэтому спланируем день вместе. В среднем индивидуальная игра проходит около 4 часов. Кто я? Почему я пришел/пришла именно в это время? Каково мое предназначение? А также многие другие запросы, касающиеся жизни. Доступна в онлайн режиме. До встречи🙏',
    en: 'To play this game is to touch divine wisdom. They come into the game with a request. The request can be fully processed in one session, which can replace years of visiting a psychologist. I take you to the bottom line. The duration of the game can be many hours, so let`s plan the day together. On average, an individual game takes about 4 hours. Who am I? Why did I come at this particular time? What is my purpose? And also many other queries related to life. Available online. See you soon🙏',
  },
  addBtn1: {
    ua: 'Замовити послугу',
    ru: 'Заказать услугу',
    en: 'Order service',
  },
  addBtn2: {
    ua: 'Замовити послугу',
    ru: 'Заказать услугу',
    en: 'Order service',
  },
  addBtn3: {
    ua: 'Замовити послугу',
    ru: 'Заказать услугу',
    en: 'Order service',
  },

  price2: { ua: 'Ціни:', ru: 'Цены:', en: 'Price:' },
  taroPrice: {
    ua: 'Консультація Таро',
    ru: 'Консультация таро',
    en: 'Tarot consultation',
  },
  lilaPrice: {
    ua: 'Гра "Ліла Чакра"',
    ru: 'Игра "Лила Чакра"',
    en: 'Leela Chakra game',
  },
  yogaPrice: { ua: 'Заняття з йоги', ru: 'Занятие йоги', en: 'Yoga class' },
  taroPricePr: {
    ua: 'Роблю розклади по хвилюючих питаннях. 1-2теми. 1-2години роботи (запис в режимі черги) - 20€. Більше 2 тем - 30€ Терміново, зараз, SOS - 30€. Особиста зустріч: розповідаю, відповідаю на питання. Онлайн: пишете питання, я відповідаю письмово або голосовими повідомленнями (за бажанням).',
    ru: 'Делаю расклад по волнующим вопросам. 1-2 темы. 1-2 часа работы (запись в режиме очереди) – 20€. Больше 2 тем - 30€ Срочно, сейчас, SOS – 30€. Личная встреча: рассказываю, отвечаю на вопросы. Онлайн: пишете вопрос, я отвечаю письменно или голосовыми сообщениями (по желанию).',
    en: 'I make schedules on exciting issues. 1-2 topics. 1-2 hours of work (recording in queue mode) - 20€. More than 2 topics - 30€ Urgent, now, SOS - 30€. Personal meeting: I tell, answer questions. Online: write questions, I will answer in writing or by voice messages (optional).',
  },
  lilaPricePr: {
    ua: 'Онлайн. Можлива особиста зустріч, але по домовленності. Індивідуальна - 30€. Групова (можете запросити від 3 до 5 людей самі, або написати мені запит, я буду збирати компанію на визначений день) - 15€ з людини.',
    ru: 'Онлайн. Возможна личная встреча, но по договоренности.Индивидуальная – 30€. Групповая (можете пригласить от 3 до 5 человексами, или написать мне запрос, я буду собирать компанию на определенныйдень) – 15€ с человека.',
    en: 'Online. A personal meeting is possible, but by arrangement. Individual - 30€. Group (you can invite from 3 to 5 people themselves, or send me a request, I will collect the company at the specified time day) - 15€ per person.',
  },
  yogaPricePr: {
    ua: 'Онлайн та особисті зустрічі. Одне заняття, 1 година - 10€. Медитацію проводжу в подарунок. Можливо придбати абонемент на місяць. 4 заняття - 30€.',
    ru: 'Онлайн и личные встречи. Одно занятие, 1 час – 10€. Медитацию провожу в подарок. Возможно поговорить об абонементе в месяц. 4 занятие – 30€.',
    en: 'Online and in-person meetings. One lesson, 1 hour - 10€. Meditation send as a gift. It is possible to talk about a subscription for a month. 4 classes - 30€.',
  },

  addBtn4: {
    ua: 'Замовити послугу',
    ru: 'Заказать услугу',
    en: 'Order service',
  },
  addBtn5: {
    ua: 'Замовити послугу',
    ru: 'Заказать услугу',
    en: 'Order service',
  },
  addBtn6: {
    ua: 'Замовити послугу',
    ru: 'Заказать услугу',
    en: 'Order service',
  },

  contacts: { ua: 'Контакти:', ru: 'Контакты:', en: 'Contacts:' },

  comName: {
    ua: 'Ви можете залишити свій відгук тут:',
    ru: 'Вы можете оставить свой отзыв здесь:',
    en: 'You can leave your feedback here:',
  },

  inpName: { ua: 'Ваше ім`я:', ru: 'Ваше имя:', en: 'Your name:' },
  inpMail: { ua: 'Ваш імейл:', ru: 'Ваш имейл:', en: 'Your mail:' },
  inpText: { ua: 'Ваш відгук:', ru: 'Ваш отзыв:', en: 'Your feedback:' },

  sendBtn: {
    ua: 'Залишити відгук',
    ru: 'Оставить отзыв',
    en: 'Post a review',
  },

  feedback:{
    ua: 'Відгуки',
    ru: 'Отзывы',
    en: 'Reviews',
  }
};

export default langArr;
